import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Course from './Course'

const CoursesContainer = styled.div`
  width: 866px;
  border-radius: 7px;
  background-color: #f8f8f8;
  overflow: hidden;

  > li:nth-child(odd) {
    background-color: #ffffff;
  }

  > li:first-of-type {
    border-radius: 7px 7px 0 0;
  }

  > li:last-of-type {
    border-radius: 0 0 7px 7px;
  }
`

const Courses = props => {
  let filteredStats = props.productionStatusStats
  if (props.hasActiveFilters) {
    filteredStats = filteredStats.filter(s => s.total_count > 0)
  }
  const courses = filteredStats.map(item => (
    <Course
      key={`course-${item.course_id}`}
      course={item}
      dispatch={props.dispatch}
      clickHandler={props.clickHandler}
      levelFilters={props.levelFilters}
    />
  ))

  return <CoursesContainer>{courses}</CoursesContainer>
}

Courses.propTypes = {
  productionStatusStats: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  hasActiveFilters: PropTypes.bool.isRequired,
  clickHandler: PropTypes.func.isRequired,
  levelFilters: PropTypes.array.isRequired
}

export default Courses



// WEBPACK FOOTER //
// ./src/components/productionstatus/Courses.js